<template>
  <div>
    <div class="vx-row w-full ">
      <div class="vx-col">
        <btn-add-tables :tables="availableTables" class="mb-4" />
      </div>
    </div>
    <vx-card>
      <vs-table stripe pagination max-items="10" search :data="availableTables">
        <template slot="header">
            <h4> 
              <strong>Mesas</strong>
            </h4>
        </template>
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>Mesa</vs-th>
          <vs-th>Cadastro</vs-th>
          <vs-th width="30"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              {{ data[indextr].id }}
            </vs-td>

            <vs-td>
              {{ data[indextr].number }}
            </vs-td>

            <vs-td>
              {{ data[indextr].createdAt | moment('DD/MM/YYYY')   }}
            </vs-td>

            <vs-td class="whitespace-no-wrap" >
              <feather-icon icon="DownloadCloudIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="downloadQrCode(tr.id)" />
              <feather-icon icon="SearchIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current mr-3 ml-3 " @click.stop="viewTableDetails(tr)" />
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="confirmRemoveTable(tr.id)" />
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <a-modal 
      :title="`Visualizando mesa ${modal.table.number}`" 
      v-model="modal.table.visible"
      :footer="null"
      :zIndex="999999"
      @cancel="modal.table.visible = false"
    >
      <table-view-details :tableId="modal.table.id" />
    </a-modal>

    <a-modal
      title="Selecione o modelo desejado"
      v-model="modal.selectQrCodeType.visible"
      :width="325"
      :footer="null"
      :zIndex="999999"
      :key="qrCodeToDownload.id"
      @cancel="modal.selectQrCodeType.visible = false"
    >
      <select-qr-code-type :table="qrCodeToDownload" />
    </a-modal>

    <!-- <component
      :key="qrCodeTableId"
      :table="qrCodeToDownload"
      :is="currentComponent"
      @downloaded="downloadedQrCode(true)"
    /> -->

    <!-- <qr-code
      :key="qrCodeTableId"
      :table="qrCodeToDownload"
      @downloaded="downloadedQrCode(true)"
    /> -->

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import TableViewDetails from '@/components/table/TableViewDetails.vue'
  import SelectQrCodeType from '@/components/table/SelectQrCodeType.vue'
  import BtnAddTables from './BtnAddTables'

  export default {
    components: {
      SelectQrCodeType,
      TableViewDetails,
      BtnAddTables,
    },

    data() {
      return {
        modal: {
          table: {
            visible: false,
            id: null
          },
          selectQrCodeType: {
            visible: false,
          },
        },
        qrCodeTableId: null,
        currentComponent: 'QrCodeModelOne',
      }
    },

    computed: {
      qrCodeToDownload() {
        return this.availableTables.find(x => x.id === this.qrCodeTableId) || {}
      },

      ...mapState('tables', ['availableTables'])
    },

    mounted() {
      this.fetchTables()
    },

    methods: {  
      downloadedQrCode() {
        this.qrCodeTableId = null  
      },

      downloadQrCode(id) {
        this.modal.selectQrCodeType.visible = true
        this.qrCodeTableId = id
      },
      
      viewTableDetails(table) {
        const findTable = this.availableTables.find(x => x.id === table.id)
        if(findTable){
          this.modal.table = { visible: true, id: table.id }
        }
      },

      confirmRemoveTable(id) {
        const self = this
        this.$confirm({
          zIndex : 99999999,
          title: this.$t('confirmYourIntention'),
          content: 'Deseja realmente remover esta mesa?',
          okText : 'Remover',
          cancelText : 'Não',
          okType: 'danger',
          async onOk () {
            self.removeTable(id)
          }
        })
      },

      ...mapActions('tables', ['fetchTables', 'removeTable'])
    }
  }
</script>